import { render, staticRenderFns } from "./ResourceComment.vue?vue&type=template&id=7fe68227&scoped=true&"
import script from "./ResourceComment.vue?vue&type=script&lang=js&"
export * from "./ResourceComment.vue?vue&type=script&lang=js&"
import style0 from "./ResourceComment.vue?vue&type=style&index=0&id=7fe68227&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe68227",
  null
  
)

export default component.exports